// extracted by mini-css-extract-plugin
export var inline = "_vt-0";